<template>
    <div>
        <div v-bind:class="ifLoading" class="loader">
            <TheSpinner />
        </div>
        <div v-if="loading">
            <the-slider-code />
            <Component
                v-for="articleItem of items"
                :key="articleItem.ID"
                :is="getArticleLayout(articleItem.type)"
                :articleItem="articleItem"
            />
        </div>

    </div>
</template>


<script>
    import TheSliderCode from "../TheSliderCode";
    import TheSpinner from "../TheSpinner"
    const countdown = () => import ('../countdown/countdown.vue');
    const news = () => import ('../news/teaser.vue');
    const formular = () => import ('../formular/formular.vue');
    const error = () => import ('../error.vue');
    const instagram = () => import ('../instagram/instagram.vue');
    const teilnehmer = () => import ('../teilnehmer/homepageTeaser.vue');
    const spielplan = () => import ('../spielplan/teaser.vue');
    const ergebnisse = () => import ('../ergebnisse/teaser.vue');
    const welcome = () => import ('../TheWelcome.vue');


    export default {
        name: 'homepage',
        components: {
            TheSliderCode,
            TheSpinner
        },
        data(){
            return{
                loading: false,
                items: []
            }
        },
        created: function(){
            const baseURI = 'https://api.pgsi2020.de/api/file/homepage.json'
            this.$http.get(baseURI)
                .then((result) => {
                    this.items = result.data,
                    this.loading = true
                })
        },
        computed: {
            ifLoading() {
                if(this.loading){
                    return 'loaded';
                }else{
                    return 'isLoading';
                }
            }
        },
        methods: {
            getArticleLayout(layout) {
                switch (layout) {
                    case 'countdown':
                        return countdown
                    case 'news':
                        return news
                    case 'formular':
                        return formular
                    case 'instagram':
                        return instagram
                    case 'teilnehmer':
                        return teilnehmer
                    case 'spielplan':
                        return spielplan
                    case 'ergebnisse':
                        return ergebnisse
                    case 'welcome':
                        return welcome

                    default:
                        return error
                }
            },
            test(){
                alert('hello world!');
            }
        }
    }
</script>

<style lang="scss">


</style>
